<template>
  <div class="analyze-users">
    <div class="analyze-users-container flex flex-dir-column">
      <el-card>
        <el-form :inline="true" size="small">
          <el-form-item label="会话ID">
            <el-input placeholder="请输入会话ID" v-model="form.sessionId"></el-input>
          </el-form-item>
          <el-form-item label="用户ID">
            <el-input placeholder="请输入用户ID" v-model="form.visitorId"></el-input>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              size="small"
              class="analyze-relation-range"
              v-model="form.range"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              :unlink-panels="true"
              :default-time="['00:00:00', '23:59:59']"
              end-placeholder="结束日期"
              :clearable="false"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
          </el-form-item>
        </el-form>
      </el-card>

      <el-card class="analyze-users-table" style="flex: 1">
        <el-table :data="list" v-loading="loading" height="100%">
          <el-table-column label="国家" prop="country"></el-table-column>
          <el-table-column label="省份" prop="province"></el-table-column>
          <el-table-column label="城市" prop="city"></el-table-column>
          <el-table-column
            label="外网ip"
            prop="ip"
            width="140px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="会话id" prop="sessionId" width="140px"></el-table-column>
          <el-table-column label="页面路由" prop="pagePath" width="140px">
            <template slot-scope="{ row }">
              <!-- eslint-disable-next-line max-len -->
              <el-link :underline="false" :href="row.pagePath" target="_blank">{{
                row.pagePath
              }}</el-link>
            </template>
          </el-table-column>
          <el-table-column
            label="页面名称"
            prop="pageName"
            width="140px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="来源" prop="source" width="120px">
            <template slot-scope="scope">{{ renderSource(scope.row.source) }}</template>
          </el-table-column>
          <el-table-column label="操作系统信息" prop="osInfo" width="140px"></el-table-column>
          <el-table-column label="事件时间" prop="eventTime" width="150px"></el-table-column>
          <el-table-column label="浏览器信息" prop="browserInfo" width="170px"></el-table-column>
          <el-table-column label="访客id" prop="visitorId"></el-table-column>
          <el-table-column label="操作" fixed="right" width="100px">
            <template slot-scope="scope">
              <el-button type="text" @click="handleView(scope.row)">用户细查</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          class="analyze-users-pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pager.pageNum"
          :page-sizes="[10, 20, 50, 100, 200, 300, 400]"
          :page-size="pager.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </el-card>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
// eslint-disable-next-line import/no-cycle
import { queryUserBehavior } from '@/api/analyze';

export default {
  data() {
    return {
      form: {
        range: [],
        visitorId: '',
        sessionId: '',
      },
      searchParams: {},
      pager: {
        pageSize: 10,
        pageNum: 1,
      },
      list: [],
      total: 0,
      loading: false,
    };
  },
  computed: {
    ...mapGetters('app', ['sourceList', 'env', 'source']),
  },
  watch: {
    env() {
      this.handleSearch();
    },
    source() {
      this.handleSearch();
    },
  },
  methods: {
    renderSource(val) {
      return this.sourceList?.filter((item) => item.key === val)[0]?.name;
    },
    /**
     * 设置默认的时间周期
     */
    setDefaultRange() {
      this.form.range = [
        new Date(
          `${moment()
            .subtract(6, 'days')
            .format('YYYY/MM/DD')} 00:00:00`,
        ),
        new Date(`${moment().format('YYYY/MM/DD')} 23:59:59`),
      ];
    },
    handleSearch() {
      this.searchParams = { ...this.form };
      this.pager.pageNum = 1;
      this.getList();
    },
    handleView(item) {
      // const [
      //   // eslint-disable-next-line no-underscore-dangle
      //   // analyzeTimeForm = moment()._d,
      //   // eslint-disable-next-line no-underscore-dangle
      //   analyzeTimeTo = moment()._d,
      // ] = this.searchParams.range;
      const to = `${moment(item.eventTime).format('YYYY-MM-DD')} 23:59:59`;
      // moment(analyzeTimeTo).format('YYYY-MM-DD HH:mm:ss');
      const form = `${moment(item.eventTime).format('YYYY-MM-DD')} 00:00:00`;
      this.$router.push({
        name: 'AnalyzeErrorReportDetail',
        query: {
          form,
          to,
          sessionId: item.sessionId,
          pageSource: 'server',
        },
      });
    },
    async getList() {
      try {
        this.loading = true;
        const [
          // eslint-disable-next-line no-underscore-dangle
          analyzeTimeFrom = moment().subtract(6, 'days')._d,
          // eslint-disable-next-line no-underscore-dangle
          analyzeTimeTo = moment()._d,
        ] = this.searchParams.range;

        const params = {
          ...this.searchParams,
          ...this.pager,
        };
        if (analyzeTimeFrom && analyzeTimeTo) {
          params.analyzeTimeFrom = moment(analyzeTimeFrom).format('YYYY-MM-DD HH:mm:ss');
          params.analyzeTimeTo = moment(analyzeTimeTo).format('YYYY-MM-DD HH:mm:ss');
        }

        delete params.range;

        const { data } = await queryUserBehavior(params);
        const { total, list } = data;
        this.list = list;
        this.total = total;
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    handleSizeChange(size) {
      this.pager.pageSize = size;
      this.pager.pageNum = 1;
      this.getList();
    },
    handleCurrentChange(num) {
      this.pager.pageNum = num;
      this.getList();
    },
  },
  mounted() {
    this.setDefaultRange();
    this.handleSearch();
  },
};
</script>
<style lang="scss">
.el-picker-panel__footer .el-picker-panel__link-btn.el-button--text {
  display: none;
}
</style>
<style scoped lang="scss">
.analyze-users-container {
  height: calc(100vh - 100px);
}
.analyze-users-table {
  /deep/.el-card__body {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
}
.analyze-users {
  &-container {
    padding: 20px;
    text-align: left;
  }

  &-table {
    margin-top: 20px;
    padding-top: 20px;
  }

  &-pagination {
    margin-top: 20px;
    text-align: right;
  }

  /deep/.el-form-item {
    margin-bottom: 0;
  }
}
</style>
